import {GenericSelect, GenericSelectItem} from 'components/Generic/Selectors';
import {useGetPlanSettings, useGetRegions} from 'hooks/swr';
import useParseURL from 'hooks/useParseURL';
import {useTranslation} from 'react-i18next';

export const RegionSelector = ({
  regionId,
  setRegionId,
}: {
  regionId?: string;
  setRegionId: (regionId: string) => void;
}) => {
  const {t} = useTranslation('common');
  const {planId} = useParseURL();
  const {data: setting} = useGetPlanSettings({resourceId: planId});
  const {data: regions} = useGetRegions({resourceId: planId});

  if (setting?.hideRegions) {
    return null;
  }

  return (
    <GenericSelect
      inputProps={{'data-testid': 'region'}}
      value={regionId ?? ''}
      onChange={(event) => {
        const regionId = event.target.value as string;
        setRegionId(regionId);
      }}
      label={t('region')}
    >
      {regions?.map((region) => (
        <GenericSelectItem key={region.id} value={region.id}>
          {region.name}
        </GenericSelectItem>
      ))}
    </GenericSelect>
  );
};
